<template>
  <Modal class="long-modal top-modal"  width="800" style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">{{(this.labelType===0) ? '查看空置跟进':'查看即将退租跟进'}}</div>
    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="tableData" :loading="loading"></table-list>
    </div>
    <div slot="footer">
      <div>  
        <Button  type="primary" size="large" @click="close">确定</Button>
      </div>
    </div>
  </Modal>
</template>
 
<script type="text/ecmascript-6">
 import {formatDateTime} from "@/utils/format.js"
 import TableList from "components/TableList/index";
 import { getForRentFollowList } from 'api/house'
 
export default {
  components:{
    TableList
  },
  props:{
    n:{
      type:Number,
      default:0
    },
    labelType:{
      type:Number,
      default:null
    },
    labelUnique:{
      type:String,
      default:''
    }
  },
  watch:{
    n() { 
      this.show = true
      this.loading = true
      let params={
        labelUnique:this.labelUnique,
        labelType:this.labelType
      }
      getForRentFollowList(params).then( res => {
        this.tableData = res.data
      }).finally( () => {
        this.loading = false
      })
    }
  },

 data () {
  return {
    tableData:[],
    show:false,
    loading:false,
    columns:[
      {
        title: "跟进时间",
        key: "createTime",
        align: "center",
        render: (h,params) => {
          return h('div',formatDateTime(params.row.createTime).slice(0, 16))
        }
      },
      {
        title: "跟进人",
        key: "createName",
        align: "center"
      
      },
      {
        title: "跟进记录",
        key: "remark",
        align: "center"
      }
    ]
  };
 },
 methods:{
   close() {
     this.show = false
   }
 }
}
</script>




